/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "scan_planner";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface TrajectoryActionPlannerStopAtWaypointReason {
}

export enum TrajectoryActionPlannerStopAtWaypointReason_Enum {
  INVALID = 0,
  STUCK = 1,
  LARGE_HEADING_CHANGE = 2,
  LOW_WAYPOINT_SPEED = 3,
  TRAJECTORY_DEFLECTION = 4,
  VEHICLE_BODY_VISIBLE = 5,
  ISP_NOT_READY = 6,
  PREV_PHOTO_STILL_ENQUEUED = 7,
  SHORT_DISTANCE_FROM_PREV_WAYPOINT = 8,
  GIMBAL_FLIP = 9,
  FIRST_WAYPOINT = 10,
  USER_REQUESTED = 11,
  UNRECOGNIZED = -1,
}

export function trajectoryActionPlannerStopAtWaypointReason_EnumFromJSON(
  object: any,
): TrajectoryActionPlannerStopAtWaypointReason_Enum {
  switch (object) {
    case 0:
    case "INVALID":
      return TrajectoryActionPlannerStopAtWaypointReason_Enum.INVALID;
    case 1:
    case "STUCK":
      return TrajectoryActionPlannerStopAtWaypointReason_Enum.STUCK;
    case 2:
    case "LARGE_HEADING_CHANGE":
      return TrajectoryActionPlannerStopAtWaypointReason_Enum.LARGE_HEADING_CHANGE;
    case 3:
    case "LOW_WAYPOINT_SPEED":
      return TrajectoryActionPlannerStopAtWaypointReason_Enum.LOW_WAYPOINT_SPEED;
    case 4:
    case "TRAJECTORY_DEFLECTION":
      return TrajectoryActionPlannerStopAtWaypointReason_Enum.TRAJECTORY_DEFLECTION;
    case 5:
    case "VEHICLE_BODY_VISIBLE":
      return TrajectoryActionPlannerStopAtWaypointReason_Enum.VEHICLE_BODY_VISIBLE;
    case 6:
    case "ISP_NOT_READY":
      return TrajectoryActionPlannerStopAtWaypointReason_Enum.ISP_NOT_READY;
    case 7:
    case "PREV_PHOTO_STILL_ENQUEUED":
      return TrajectoryActionPlannerStopAtWaypointReason_Enum.PREV_PHOTO_STILL_ENQUEUED;
    case 8:
    case "SHORT_DISTANCE_FROM_PREV_WAYPOINT":
      return TrajectoryActionPlannerStopAtWaypointReason_Enum.SHORT_DISTANCE_FROM_PREV_WAYPOINT;
    case 9:
    case "GIMBAL_FLIP":
      return TrajectoryActionPlannerStopAtWaypointReason_Enum.GIMBAL_FLIP;
    case 10:
    case "FIRST_WAYPOINT":
      return TrajectoryActionPlannerStopAtWaypointReason_Enum.FIRST_WAYPOINT;
    case 11:
    case "USER_REQUESTED":
      return TrajectoryActionPlannerStopAtWaypointReason_Enum.USER_REQUESTED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TrajectoryActionPlannerStopAtWaypointReason_Enum.UNRECOGNIZED;
  }
}

export function trajectoryActionPlannerStopAtWaypointReason_EnumToJSON(
  object: TrajectoryActionPlannerStopAtWaypointReason_Enum,
): string {
  switch (object) {
    case TrajectoryActionPlannerStopAtWaypointReason_Enum.INVALID:
      return "INVALID";
    case TrajectoryActionPlannerStopAtWaypointReason_Enum.STUCK:
      return "STUCK";
    case TrajectoryActionPlannerStopAtWaypointReason_Enum.LARGE_HEADING_CHANGE:
      return "LARGE_HEADING_CHANGE";
    case TrajectoryActionPlannerStopAtWaypointReason_Enum.LOW_WAYPOINT_SPEED:
      return "LOW_WAYPOINT_SPEED";
    case TrajectoryActionPlannerStopAtWaypointReason_Enum.TRAJECTORY_DEFLECTION:
      return "TRAJECTORY_DEFLECTION";
    case TrajectoryActionPlannerStopAtWaypointReason_Enum.VEHICLE_BODY_VISIBLE:
      return "VEHICLE_BODY_VISIBLE";
    case TrajectoryActionPlannerStopAtWaypointReason_Enum.ISP_NOT_READY:
      return "ISP_NOT_READY";
    case TrajectoryActionPlannerStopAtWaypointReason_Enum.PREV_PHOTO_STILL_ENQUEUED:
      return "PREV_PHOTO_STILL_ENQUEUED";
    case TrajectoryActionPlannerStopAtWaypointReason_Enum.SHORT_DISTANCE_FROM_PREV_WAYPOINT:
      return "SHORT_DISTANCE_FROM_PREV_WAYPOINT";
    case TrajectoryActionPlannerStopAtWaypointReason_Enum.GIMBAL_FLIP:
      return "GIMBAL_FLIP";
    case TrajectoryActionPlannerStopAtWaypointReason_Enum.FIRST_WAYPOINT:
      return "FIRST_WAYPOINT";
    case TrajectoryActionPlannerStopAtWaypointReason_Enum.USER_REQUESTED:
      return "USER_REQUESTED";
    case TrajectoryActionPlannerStopAtWaypointReason_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseTrajectoryActionPlannerStopAtWaypointReason(): TrajectoryActionPlannerStopAtWaypointReason {
  return {};
}

export const TrajectoryActionPlannerStopAtWaypointReason = {
  encode(_: TrajectoryActionPlannerStopAtWaypointReason, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TrajectoryActionPlannerStopAtWaypointReason {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTrajectoryActionPlannerStopAtWaypointReason();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): TrajectoryActionPlannerStopAtWaypointReason {
    return {};
  },

  toJSON(_: TrajectoryActionPlannerStopAtWaypointReason): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<TrajectoryActionPlannerStopAtWaypointReason>, I>>(
    base?: I,
  ): TrajectoryActionPlannerStopAtWaypointReason {
    return TrajectoryActionPlannerStopAtWaypointReason.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TrajectoryActionPlannerStopAtWaypointReason>, I>>(
    _: I,
  ): TrajectoryActionPlannerStopAtWaypointReason {
    const message = createBaseTrajectoryActionPlannerStopAtWaypointReason();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
